<template>
  <section class="product">
    <template v-if="detail.id">
      <div class="banner" v-if="detail.banner" v-cbs="'服务详情页-头图'">
        <van-swipe autoplay="5000" indicator-color="#fff" width="100%">
          <van-swipe-item v-for="(item, index) in detail.banner" :key="index">
            <img :src="item | replaceUrlProtocol">
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="price-area">
        <div class="price-rmb" :class="{ topic: detail.activity_money_info.type && detail.activity_money_info.type !== 'vip' }" v-if="detail.service_class != 1 || detail.type != 3">
          <span>￥</span>
          <strong class="rmb">
            <template v-if="detail.activity_money_info.type && detail.activity_money_info.type !== 'vip'">{{ detail.activity_money_info.activity_money }}</template>
            <template v-else>{{ detail.now_money }}</template>
          </strong>
          <strong v-if="detail.service_class == 1">/首</strong>
          <template v-if="detail.activity_money_info.type">
            <span class="price-vip" v-if="detail.activity_money_info.type === 'vip'">
              ￥{{ detail.activity_money_info.activity_money }}
            </span>
            <template v-else>
              <div class="price-original">
                ￥{{ detail.now_money }}
              </div>
              <div class="topic-name">
                {{ detail.activity_money_info.name }}
              </div>
            </template>
          </template>
        </div>
        <div class="product-name">{{ detail.name }}</div>
        <ul class="ensure-lists">
          <li>平台保障</li>
          <li class="item" v-for="(item, index) in detail.guarantee" :key="index">{{ item.title }}</li>
        </ul>
      </div>

      <div class="product-choose">
        <ul class="product-choose-lists">
          <li v-cbs="'服务详情页-已选服务'">
            <div class="select-title">已选服务</div>
            <div class="select-content arrow-right" @click="openProductPicker">{{ detail.name }}</div>
          </li>
        </ul>
      </div>

      <div class="product-choose">
        <ul class="product-choose-lists">
          <li @click="servicePopup = true" v-cbs="'服务详情页-服务项目'" v-if="detail.other_attribute && detail.other_attribute.abstract">
            <div class="select-title">服务项目</div>
            <div class="select-content arrow-right">{{ detail.other_attribute.abstract }}</div>
          </li>
          <li v-for="(item, index) in detail.specification" :key="index" v-cbs="`服务详情页-${item.title}`">
            <div class="select-title">{{ item.title }}</div>
            <div class="select-content">{{ item.desc }}</div>
          </li>
        </ul>
      </div>

      <div class="details-area" v-cbs="'服务详情页-商品详情'">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="detail.introduction_html" ref="detail"></div>
      </div>

      <section class="footer">
        <div class="inner">
          <div class="action">
            <div class="home">
              <a href="javascript:;" class="btn" @click="goHome">首页</a>
            </div>
            <div class="buy">
              <template v-if="detail.service_class == 1 && detail.type == 2 && isTimeOver">
                <a href="javascript:;" class="btn disable">请在 9:00 - 21:00 下单</a>
              </template>

              <template v-else>

                <template v-if="detail.service_class == 1 && detail.type == 3">
                  <router-link
                    class="btn split"
                    :to="{
                      path: '/buy',
                      query: {
                        product_id: detail.id,
                        star_userid: $route.query.star_userid
                      }
                    }"
                    v-if="isLogin"
                    v-cbs="{ name: '服务详情页-立即购买', product_id: detail.id }">
                    <div class="hd">
                      下单后立即制作<br>
                      试听满意付尾款
                    </div>
                    <div class="line"></div>
                    <div class="bd">
                      立即支付定金<br>
                      <small>¥{{ detail.deposit_money }}</small>
                    </div>
                  </router-link>
                  <a href="javascript:;" class="btn split" @click="openApp(`/product/${detail.id}`, {
                    star_userid: $route.query.star_userid
                  })" v-else>
                    <div class="hd">
                      下单后立即制作<br>
                      试听满意付尾款
                    </div>
                    <div class="line"></div>
                    <div class="bd">
                      立即支付定金<br>
                      <small>¥{{ detail.deposit_money }}</small>
                    </div>
                  </a>
                </template>

                <template v-else>
                  <router-link
                    class="btn"
                    :class="{ vip: detail.activity_money_info.type === 'vip' && detail.ismember === 1 }"
                    :to="{
                      path: '/buy',
                      query: {
                        product_id: detail.id,
                        star_userid: $route.query.star_userid
                      }
                    }"
                    v-if="isLogin"
                    v-cbs="{ name: '服务详情页-立即购买', product_id: detail.id }">
                    立即购买
                  </router-link>
                  <a href="javascript:;" class="btn" @click="openApp(`/product/${detail.id}`, {
                    star_userid: $route.query.star_userid
                  })" v-else>立即购买</a>
                </template>

              </template>
            </div>
          </div>
        </div>
      </section>

      <van-popup v-model="productPicker" position="bottom">
        <van-picker show-toolbar :default-index="productPickerDefault" :columns="productPickerData" @cancel="productPicker = false" @confirm="switchProduct" />
      </van-popup>

      <van-popup v-model="servicePopup" round position="bottom" :style="{ height: '40%' }">
        <div class="service-desc" v-if="detail.other_attribute">
          {{ detail.other_attribute.desc }}
        </div>
      </van-popup>
    </template>

    <mall-float-navigator v-show="false" ref="navigator" />
  </section>
</template>

<script>
import commonObj from 'commonObj';
import qs from 'qs';
import dayjs from 'dayjs';
import MallFloatNavigator from '../components/FloatNavigator';

export default {
  name: 'Product',

  components: {
    MallFloatNavigator
  },

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      detail: {},

      productPicker: false,
      productPickerData: [],
      productPickerDefault: 0,

      servicePopup: false
    }
  },

  computed: {
    isLogin() {
      return this.$curuserid && this.$token;
    },

    isTimeOver() {
      return dayjs().hour() < 9 || dayjs().hour() >= 21;
    }
  },

  watch: {
    id() {
      this.refresh();
    }
  },

  created() {
    this.refresh();
  },

  methods: {
    async refresh() {
      this.$toast.loading();

      let idName = 'productid';

      if (this.$route.query.id_type === 'anchorid') {
        idName = 'anchorid';
      }

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getProductInfo', {
        data: {
          [idName]: this.id
        }
      });

      this.$toast.clear();

      if (code === 1) {
        if (!data.id) {
          const query = { ...this.$route.query, back_musicboard: undefined };
          this.$router.replace({ path: '/', query }, () => {});

          return;
        }

        this.detail = data;

        document.title = this.detail.name ?? '人工修音';
      }
    },

    async getProducts() {
      if (this.productPickerData.length) {
        return;
      }

      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getAllProductInfo', {
        data: {
          typeClass: this.detail.service_class
        }
      });

      this.$toast.clear();

      if (code === 1) {
        const allProducts = data;
        const products = [];

        this.productPickerDefault = 0;

        allProducts.forEach((item, index) => {
          if (item.hide == 1) {
            return;
          }

          products.push({
            id: item.id,
            text: item.name
          });

          if (item.id == this.detail.id) {
            this.productPickerDefault = index;
          }
        });

        this.productPickerData = products;
      }
    },

    switchProduct(item) {
      this.productPicker = false;

      this.$router.replace({ path: `/product/${item.id}` }, () => {});
    },

    openProductPicker() {
      this.productPicker = true;

      // 解决 loading 被 popup 盖住的问题（后弹出的永远会遮住先弹出的）
      this.$nextTick(() => {
        this.getProducts();
      });
    },

    openApp(uri, params) {
      let url = `${window.location.origin}${this.$router.options.base}${uri}`;
      const query = qs.stringify(params);

      if (query) {
        url += `?${query}`;
      }

      commonObj.utils.openApp(false, url);
    },

    goHome() {
      if (this.$refs.navigator.isMusicboard) {
        this.$refs.navigator.gotoMusicboard();
      }
      else {
        this.$router.push({
          path: '/',
          query: {
            star_userid: this.$route.query.star_userid
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@cdn_js/styles/product.scss";
</style>
